import { AbstractDesktopResourceConfigBuilder } from 'tag/ts/tag/player/adapters/avia/resources/abstract/AbstractDesktopResourceConfigBuilder';
import { AssetUrlPlaybackUtility } from 'tag/ts/tag/player/adapters/avia/utilities/AssetUrlPlaybackUtility';
export class DesktopAssetUrlResourceConfigBuilder extends AbstractDesktopResourceConfigBuilder {
    constructor(argument) {
        super({
            name: 'DesktopAssetUrlResourceConfigBuilder',
            ...argument
        });
        this.assetPlaybackUtil = new AssetUrlPlaybackUtility(argument);
    }
    getResult() {
        return new Promise((resolve, reject) => {
            super.getResult().then((data) => {
                let resource = data?.resource;
                resource = this.setMediaUrl(resource);
                resource = this.setDrm(resource);
                resource = this.configureNflLts(resource);
                resource = this.deepMergeResourceFromSmartTagParams(resource);
                resource = this.sanitizeResource(resource);
                resource = this.testOverrides(resource);
                resolve({ msg: 'Resource config', resource: resource });
            });
        });
    }
    setMediaUrl(resource) {
        return super.setMediaUrl(resource, this.assetPlaybackUtil?.getMediaUrl());
    }
}
